export const TOGGLE_OPTIONAL_TEXT = 'TOGGLE_OPTIONAL_TEXT';
export const CHANGE_TEXT = 'CHANGE_TEXT';
//# sourceMappingURL=constants.js.map